import { z } from 'zod';

export const createPoolSchema = z.object({
  name: z.string().min(3, 'Nome deve ter pelo menos 3 caracteres'),
  description: z.string().max(500, 'Descricao muito longa').optional(),
  isPublic: z.preprocess((value) => value === true || value === 'true', z.boolean()),
});

export type CreatePoolForm = z.infer<typeof createPoolSchema>;
